// extracted by mini-css-extract-plugin
export var StyledHam = "Hamburguer-module--StyledHam--6e6d7";
export var active = "Hamburguer-module--active--3bfe9";